(function() {
    'use strict';

    angular
        .module('valueconnectApp')
        .controller('AppraisalOrderDeleteController',AppraisalOrderDeleteController);

    AppraisalOrderDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppraisalOrder'];

    function AppraisalOrderDeleteController($uibModalInstance, entity, AppraisalOrder) {
        var vm = this;

        vm.appraisalOrder = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppraisalOrder.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
